import React from 'react';
import { SpacingBox } from '../Boxes';
import { ProductCard } from './ProductCard';
import { ProductPresenter } from '../../presenters';

export const InlineProductList = ({ products, onClick }) => (
  <div className="row" style={{width:'100%'}}>
    {products.map((product) => (
      <div className="col-md-2 col-sm-12" key={ProductPresenter(product).number}>
          <SpacingBox marginVertical="lg">
            <ProductCard
              onClick={onClick}
              product={ProductPresenter(product)}
            />
          </SpacingBox>
      </div>
    ))}
  </div>
);
